import { render, staticRenderFns } from "./ReceiptPaper.vue?vue&type=template&id=5b2a7e4f&scoped=true&"
import script from "./ReceiptPaper.vue?vue&type=script&lang=js&"
export * from "./ReceiptPaper.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptPaper.vue?vue&type=style&index=0&id=5b2a7e4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a7e4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Projects/Coding/Nhafatura/appfactura-spa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VContainer,VDialog,VDivider,VFlex,VIcon,VLayout,VProgressLinear,VSpacer,VToolbar,VToolbarTitle})
